import io from "socket.io-client";
// @ts-nocheck
import { Toast as showToast } from "core/components/global/toast/toast";
import { fetchBaseUrl } from "core/utils/common";

const baseURL = fetchBaseUrl({});


let socket;

export const initSocket = () => {
  socket = io(baseURL, {
    transports: ['websocket'],
    secure: true,
    timeout: 300000,                 // 5 minute timeout for large uploads
    // Add these for better upload stability:
    reconnection: true,              // Enable auto-reconnection
    reconnectionAttempts: 5,         // Limit attempts
    reconnectionDelay: 1000,         // 1s between attempts
    upgrade: false,                  // Don't upgrade transport
    forceNew: false                  // Allow connection reuse
  });
  
  return socket;
};

export const connectSocket = () => {
  try {
    return new Promise((resolve, reject) => {
      socket.on('connect', () => {
        console.log('Connected to the server');
        resolve(socket);
      });

      socket.on('connect_error', (err) => {
        console.error('Connection failed:', err);
        reject(err);
      });

      socket.on('disconnect', () => {
        console.log("Disconnected from server");
      })
    });
  } catch (error) {
    showToast("Unable to connect to the backend server for Socket connections, please contact an admin", "error")
  }
};

export const disconnectSocket = () => {
  socket.disconnect();
};
